import api from '../services/api';
import { $Qll, $Q } from '../utils/query-selector';
import { dataToggle, toggleDataActive, toggleAriaBusy } from '../utils/toggle-dataset';
import {
  updateCartItems,
  updateDiagnosticCartItems,
  updatetotalPrice,
  updateRecommended,
  updateUpsell,
  updateCartbutton,
  updatePriceItem,
  updateCartItem,
  updateCartQuantity,
  updateEmptyCart,
  updatePromocode
} from './update-cart';
import { renderQuantityLimit } from '../utils/input-quantity';

import { sliderUpsell } from "./slider-swiper"

import { updateBarProgress, barProgress, checkShippingCodesOnLoad } from '../utils/bar-progress';
import { checkModalCart } from './modal-cart';

const cart = $Q('.js-cart .cart-wrapper');

const SECTIONS_TO_RENDER = cart.getAttribute('data-section-id');
const MAINPRODUCT_TO_RENDER = 'main-product';

const GIFT_CARD_PROPERTY_KEYS = {
  recipientEmail: 'Recipient email',
  message: 'Message',
  recipientName: 'Recipient name',
  senderName: 'Sender name',
  sendOn: 'Send on',
};

const formatCartErrorMessage = (description) => {
  if (!description) return '';
  if (typeof description === 'string') return description;
  if (Array.isArray(description)) return description.filter(Boolean).join(' ');
  if (typeof description === 'object') {
    return Object.values(description).flat().filter(Boolean).join(' ');
  }
  return String(description);
};

$Qll('.progress-bar__container').forEach((item) => {
  barProgress(item);
});


checkShippingCodesOnLoad();


/**
 * Listen if add to cart form is submited
 * if add to cart form is submited add products in cart
 *
 * @param {string} formQuery - className reference in form add-to-cart
 *
 * To active this feature - ADD className 'add-product-cart' in form product
 * */

//  window.btnAddToCart = (formQuery) => {
//   const addForms = $Qll(formQuery);

//   if (addForms != null) {
//     addForms.forEach((form) => {
//       if (form.dataset.submit === 'true') return;

//       submitForm(form);
//       form.dataset.submit = true;
//     });
//   }
// };

export const btnAddToCart = (formQuery) => {
  const addForms = $Qll(formQuery);

  if (addForms != null) {
    addForms.forEach((form) => {
      form.classList.remove('jc-pointer-events-none');
      if (form.dataset.submit === 'true') return;
      submitForm(form);
      form.dataset.submit = true;
    });
  }
};

window.btnAddToCart = btnAddToCart

export const initRedirectToPdp = () => {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.js-redirect-to-pdp');
    if (!btn || btn.closest('.jc-pointer-events-none')) return;
    e.preventDefault();
    const productCard = btn.closest('.js-product-card, .product-card');
    if (!productCard) return;
    const productUrl = btn.dataset.productUrl || productCard.querySelector('.product-card__head')?.getAttribute('href');
    const activeOption = productCard.querySelector('.jc-variant-option.active');
    const variantId = activeOption?.dataset.variant || btn.dataset.variant || productCard.querySelector('.product-card__head')?.dataset?.variant;
    if (!productUrl) return;
    const base = variantId ? `${productUrl}?variant=${variantId}` : productUrl;
    const hash = window.innerWidth < 1024 ? '#main-product__subscriptions-add' : '';
    window.location.href = `${base}${hash}`;
  });
};

export const initStraightAddToCart = () => {
  if (!SECTIONS_TO_RENDER) return;
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.js-straight-add-to-cart');
    if (!btn || btn.closest('.jc-pointer-events-none')) return;
    e.preventDefault();
    const productCard = btn.closest('.js-product-card, .product-card');
    if (!productCard) return;
    const activeOption = productCard.querySelector('.jc-variant-option.active');
    const variantId = activeOption?.dataset.variant
      || btn.dataset.variant
      || productCard.querySelector('.product-card__head')?.dataset?.variant;
    if (!variantId) return;
    checkModalCart();
    dataToggle($Q('.js-cart'), true);
    const response = await api.addToCart({
      items: [{ id: variantId, quantity: 1 }],
      sections: [SECTIONS_TO_RENDER, MAINPRODUCT_TO_RENDER],
    });
    if (response?.status === 422) {
      showErrorMessage(response.data?.description);
      return;
    }
    if (response?.sections) {
      updateEmptyCart(response.sections[SECTIONS_TO_RENDER]);
      updateCartItems(response.sections[SECTIONS_TO_RENDER]);
      updateDiagnosticCartItems(response.sections[SECTIONS_TO_RENDER]);
      updateCartbutton(response.sections[SECTIONS_TO_RENDER]);
      updatetotalPrice(response.sections[SECTIONS_TO_RENDER]);
      updateRecommended(response.sections[MAINPRODUCT_TO_RENDER]);
      updateUpsell(response.sections[SECTIONS_TO_RENDER]);
      updateCartQuantity(response.sections[SECTIONS_TO_RENDER]);
      updateBarProgress(response.sections[SECTIONS_TO_RENDER]);
      updatePromocode(response.sections[SECTIONS_TO_RENDER]);
    }
  });
};

const submitForm = async (form) => {
  return form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const added = await addProducts(e, form);

    if (!added) return;

    checkModalCart();

    if  (e.target.dataset.form != 'upsell' && !e.target.dataset.diagnostic) {
      dataToggle($Q('.js-cart'), true);
    } else if (e.target.dataset.diagnostic && window.innerWidth < 992) {
      dataToggle($Q('.js-cart'), true);
    }
  });
};

const getProductFormControls = (form, modalCart, isModalActive, name) => {
  const formId = form.getAttribute('id');
  const productScope = isModalActive
    ? modalCart
    : form.closest('#main-product__detail') || document;
  const externalSelector = formId
    ? `[data-main-product-form-control="${formId}"][name="${name}"]`
    : null;
  const externalControls = externalSelector
    ? $Qll(externalSelector, productScope)
    : [];
  const formControls = [...(form.elements || [])].filter((control) => control.name === name);

  return externalControls.length ? externalControls : formControls;
};

const getProductFormControl = (form, modalCart, isModalActive, name, value) => {
  const controls = getProductFormControls(form, modalCart, isModalActive, name);

  if (value) {
    return controls.find((control) => control.value === value);
  }

  return controls[0];
};

const getCheckedProductFormControl = (form, modalCart, isModalActive, name) => {
  return getProductFormControls(form, modalCart, isModalActive, name).find(
    (control) => control.checked
  );
};

const removeRelatedUpsellCard = (form) => {
  if (form.dataset.form !== 'recommended') return;

  const productId = form.dataset.product;
  const currentCard = productId
    ? document.querySelector(`[data-related-upsell-card="${productId}"]`)
    : null;
  const card = currentCard || form.closest('[data-related-upsell-card]');

  if (!card) return;

  const separator = card.nextElementSibling?.matches('[data-related-upsell-separator]')
    ? card.nextElementSibling
    : null;

  separator?.remove();
  card.remove();
};

/**
 * Add products in cart
 * @param {event} event -Event submit from add to cart form
 * @param {HTMLElement} form - It is the form as a parent
 */
const addProducts = async (event, form) => {

  const modalCart = $Q('.modal-cart');
  const isModalActive = modalCart.dataset && modalCart.dataset.active === "true";
  const sellingPlan = getCheckedProductFormControl(form, modalCart, isModalActive, 'selling_plan');
  const quantityInput = getProductFormControl(form, modalCart, isModalActive, 'quantity');
//  const isDiagnostic = form.dataset.diagnostic ? form.dataset.diagnostic : null;

  let itemInCart;

  let inputQuantity = 1;

  if (quantityInput) {
    inputQuantity = quantityInput.value;
  }

  let items = [];

  const subscribeRadioBtn = getProductFormControl(
    form,
    modalCart,
    isModalActive,
    'subscriptions',
    'subscribe'
  );
  const sellingPlanValue = sellingPlan && sellingPlan.value;
  const sellingPlanCheck = subscribeRadioBtn && subscribeRadioBtn.checked;

  // Add custom gift card properties only if the customer opted in to sending it as a gift
  let properties;
  const sendAsGift = document.querySelector('#RecipientForm-sendAsGift');
  if (sendAsGift && sendAsGift.checked && document.querySelector('#Recipient-email')) {
    if (typeof window.jollyValidateGiftFields === 'function' && !window.jollyValidateGiftFields()) {
      return false;
    }

    const senderNameInput = document.querySelector('#Recipient-sender-name');
    const messageInput = document.querySelector('#Recipient-message');
    const sendOnInput = document.querySelector('#Recipient-send-on');
    const recipientName = document.querySelector('#Recipient-name').value;
    const recipientEmail = document.querySelector('#Recipient-email').value;
    const senderName = senderNameInput ? senderNameInput.value : '';
    const message = messageInput ? messageInput.value : '';
    const sendOnDate = sendOnInput && sendOnInput.value ? sendOnInput.value : '';
 
    properties = {
      [GIFT_CARD_PROPERTY_KEYS.recipientEmail]: recipientEmail,
      [GIFT_CARD_PROPERTY_KEYS.message]: message,
      [GIFT_CARD_PROPERTY_KEYS.recipientName]: recipientName,
      [GIFT_CARD_PROPERTY_KEYS.senderName]: senderName,
      [GIFT_CARD_PROPERTY_KEYS.sendOn]: sendOnDate,
      __shopify_offset: new Date().getTimezoneOffset().toString(),
      __shopify_send_gift_card_to_recipient: 'on',
      __selling_plan: sellingPlanCheck ? sellingPlanValue : null,
    };

   
  }

  const variantInputs = getProductFormControls(form, modalCart, isModalActive, 'id');

  for (const input of variantInputs) {
    items.push({ id: input.value, quantity: inputQuantity, selling_plan: sellingPlanCheck ? sellingPlanValue : null, properties: properties ? properties : null })
  }


  const cartParams = {
    items: items,
    sections: [SECTIONS_TO_RENDER, MAINPRODUCT_TO_RENDER],
  };

  const response = await api.addToCart(cartParams);

  if (response && response.status === 422) {
    const description = response.data && response.data.description;
    showErrorMessage(formatCartErrorMessage(description) || (response.data && response.data.message));
    return false;
  }

  let sections = response.sections;

  // if (quantityInput) {
  //   quantityInput.value = 1;
  // }
 
  updateEmptyCart(sections[SECTIONS_TO_RENDER]);
  updateCartItems(sections[SECTIONS_TO_RENDER]);
  updateDiagnosticCartItems(sections[SECTIONS_TO_RENDER]);
  updateCartbutton(sections[SECTIONS_TO_RENDER]);
  updatetotalPrice(sections[SECTIONS_TO_RENDER]);
  updateRecommended(sections[MAINPRODUCT_TO_RENDER]);
  updateUpsell(sections[SECTIONS_TO_RENDER]);
  updateCartQuantity(sections[SECTIONS_TO_RENDER]);
  updateBarProgress(sections[SECTIONS_TO_RENDER]);
  updatePromocode(sections[SECTIONS_TO_RENDER]);
  removeRelatedUpsellCard(form);

  document.dispatchEvent(new CustomEvent('update-diagnostic-cart'))

  if (quantityInput) {
    renderQuantityLimit(quantityInput.id);
  }

  await checkGift();

  return true;
};

/**
 * Set an error message in cart
 * @param {String} description - as an inner text
 */
export const showErrorMessage = (description) => {
  const text = $Qll('.cart__error');

  if (!text) return;

  const defaultText = text[0] && text[0].dataset && text[0].dataset.text;
  const innerText = formatCartErrorMessage(description) || defaultText;

  text.forEach(item => {
    item.innerText = innerText;

    item.classList.add('cart__error--show');

    setTimeout(() => {
      item.classList.remove('cart__error--show');
    }, 5000);
  })
}

/**
 * Event onChange in the cart item
 */

export const onChangeItemCart = () => {
  let debounceTimer;
  $Qll('.item-cart-js input').forEach((input) => {
    input.addEventListener('change', function (e) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
         updateCart(this.id, this.value, e);
      }, 300);
    });
  });
};

/**
 * Update quantity for each item in cart
 * @param {number} id Product ID
 * @param {number} quantity new quantity
 * @param {event} e - Javascript event
 */
export const getCart = async () => {
  const sectionId = cart.getAttribute('data-section-id');
  const url = `/?sections=${sectionId}`;
  try {
    const response = await fetch(url);
    const data = await response.json();
    const sectionHtml = data[sectionId];
    if (sectionHtml) {
      updateCartItems(sectionHtml);
      updateCartQuantity(sectionHtml);
      updateCartbutton(sectionHtml);
      updateBarProgress(sectionHtml);
    }
  } catch (error) {
    console.error('Error fetching section:', error);
    return null;
  }
};

export const updateCart = async (id, quantity, e) => {
  const { target } = e;
  const cartItem = target.closest('.js-cart-item');
  const itemKey = cartItem?.dataset.liveItemKey;
  const loading = cartItem ? $Q('.cart-item__loading', cartItem) : null;
  const cartParams = {
    id: itemKey || id,
    quantity: quantity,
    sections: [SECTIONS_TO_RENDER, MAINPRODUCT_TO_RENDER],
  }

  toggleAriaBusy(cartItem);
  dataToggle(loading);

  const { sections } = await api.changeCart(cartParams);

  if (quantity == 0) {
    updateCartItems(sections[SECTIONS_TO_RENDER]);
    updateDiagnosticCartItems(sections[SECTIONS_TO_RENDER]);
  } else {
    updatePriceItem(sections[SECTIONS_TO_RENDER], id, itemKey);
    updateCartItem(sections[SECTIONS_TO_RENDER], itemKey);
  }

  updateEmptyCart(sections[SECTIONS_TO_RENDER]);
  updatetotalPrice(sections[SECTIONS_TO_RENDER]);
  updateRecommended(sections[MAINPRODUCT_TO_RENDER]);
  updateUpsell(sections[SECTIONS_TO_RENDER]);
  updateCartbutton(sections[SECTIONS_TO_RENDER]);
  updateCartQuantity(sections[SECTIONS_TO_RENDER]);
  updateBarProgress(sections[SECTIONS_TO_RENDER]);
  updatePromocode(sections[SECTIONS_TO_RENDER]);
  toggleAriaBusy(cartItem);
  dataToggle(loading);

  document.dispatchEvent(new CustomEvent('update-diagnostic-cart'));
  renderQuantityLimit(id);

  await checkGift();
};

/**
 * Delete item in cart
 * listen if delete button is clicked
 * if is clicked, update cart with quantity 0
 */
export const deleteItem = () => {
  const deleteIcon = $Qll('.item-delete');

  if (deleteIcon) {
    deleteIcon.forEach((element) => {
      element.addEventListener('click', (e) => {
        updateCart(element.dataset.id, 0, e);
      });
    });
  }
};

/**
 * Open and close side cart with various buttons
 */
export const openCloseCart = () => {
  const cartContainer = $Q('.cart');

  if (!cartContainer) return null;
  cartContainer.setAttribute('data-active', 'false');

  toggleDataActive('.cart-close', '.shopify-section-group-cart-group', {
    overlay: true,
  });

  toggleDataActive('.cart-arrow-close', '.shopify-section-group-cart-group', {
    overlay: true,
  });

  const cartButton = $Q('.cart-button');
  if (cartButton) {
    cartButton.addEventListener('click', () => {
      requestAnimationFrame(() => requestAnimationFrame(() => sliderUpsell()));
    });
  }

  toggleDataActive('.cart-button', '.shopify-section-group-cart-group', {
    overlay: true,
  });
};

export const onLoadEmptyCart = () => {
  if (typeof window === 'undefined') return;
  if (!window.location.pathname.includes('cart')) return;

  window.addEventListener('load', () => {
    const cartPage = $Q('.cart-page');

    if (!cartPage) return;

    const cartWrapper = $Q('.wrapper', cartPage);
    const cartEmptyInfo = $Q('.cart-empty', cartPage);

    if (!cartWrapper || !cartEmptyInfo) return;

    const isCartEmpty = cartWrapper.dataset.empty === 'true' ? true : false;

    if (isCartEmpty) {
      cartEmptyInfo.classList.remove('hidden');
    }
  })
}

/**
 *  This function handles opening side cart from
 *  header icon
 */
export const openCartFromHeader = () => {
  const headerIcon = $Q('.js-cart-button--link');

  if (!headerIcon) return;

  document.addEventListener('DOMContentLoaded', () => {
    headerIcon.classList.remove('jc-pointer-events-none');
  })

  headerIcon.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    const header = $Q('.shopify-section-group-cart-group');

    if (!header) return;

    dataToggle(header, true);
    checkEmptySideCart();
    requestAnimationFrame(() => requestAnimationFrame(() => sliderUpsell()));
  })
}

/**
 *  This function checks if cart is empty when is opened
 *  from header icon
 */
const checkEmptySideCart = () => {
  const cartWrapper = $Q('.cart-wrapper');
  const cartItems = $Q('.cart .cart-wrapper .cartitems-js #cart-items');

  if (!cartWrapper || !cartItems) return;

  if (!Object.values(cartItems.children).length) {
    cartWrapper.classList.add('cart-wrapper--empty');
  }
}

export const checkGift = async () => {
  try {
    console.log('Running checkGift');
    const response = await fetch('/cart.js');
    const data = await response.json();
    
    let itemsToRemove = [];
    
    for (const item of data.items) {
      if (item.properties._gift && item.properties._promocode) {
        const minCartPrice = item.properties._minCartPrice;
        const minCartQuantity = item.properties._minCartQuantity;
        
        // Calculate total price without current gift item
        const totalPriceWithoutGift = data.items
          .filter(cartItem => cartItem.key !== item.key)
          .reduce((sum, cartItem) => sum + (cartItem.final_line_price || cartItem.line_price || 0), 0);
        
        // Calculate total quantity without current gift item
        const totalQuantityWithoutGift = data.items
          .filter(cartItem => cartItem.key !== item.key)
          .reduce((sum, cartItem) => sum + cartItem.quantity, 0);
        
        let shouldRemove = false;

        if (minCartPrice && minCartPrice !== '') {
          const minPrice = parseFloat(minCartPrice) * 100;
          if (!isNaN(minPrice) && totalPriceWithoutGift < minPrice) {
            shouldRemove = true;
          }
        }

        if (minCartQuantity && minCartQuantity !== '') {
          const minQuantity = parseInt(minCartQuantity, 10);
          if (!isNaN(minQuantity) && totalQuantityWithoutGift < minQuantity) {
            shouldRemove = true;
          }
        }
        
        // Collect items to remove
        if (shouldRemove) {
          itemsToRemove.push(item.key);
        }
      }
    }
    
    // Remove all items that don't meet requirements
    if (itemsToRemove.length > 0) {
      for (const itemKey of itemsToRemove) {
        await api.changeCart({
          id: itemKey,
          quantity: 0,
          sections: [SECTIONS_TO_RENDER, MAINPRODUCT_TO_RENDER],
        });
      }
      
      // Fetch updated cart sections and update UI
      const url = `/?sections=${SECTIONS_TO_RENDER},${MAINPRODUCT_TO_RENDER}`;
      const sectionsResponse = await fetch(url);
      const sectionsData = await sectionsResponse.json();
      const sections = sectionsData;

      updateEmptyCart(sections[SECTIONS_TO_RENDER]);
      updateCartItems(sections[SECTIONS_TO_RENDER]);
      updateDiagnosticCartItems(sections[SECTIONS_TO_RENDER]);
      updateCartbutton(sections[SECTIONS_TO_RENDER]);
      updatetotalPrice(sections[SECTIONS_TO_RENDER]);
      updateRecommended(sections[MAINPRODUCT_TO_RENDER]);
      updateUpsell(sections[SECTIONS_TO_RENDER]);
      updateCartQuantity(sections[SECTIONS_TO_RENDER]);
      updateBarProgress(sections[SECTIONS_TO_RENDER]);
      updatePromocode(sections[SECTIONS_TO_RENDER]);
      
      document.dispatchEvent(new CustomEvent('update-diagnostic-cart'));
    }
  } catch (error) {
    console.error('Error checking gift items:', error);
    return null;
  }
}
